import { SOFTWARE } from '../constant/actionTypes';

const getSoftwarePlatformsList = (state, action) => {
  switch (action.type) {
    case SOFTWARE.PLATFORMS.INITIATE:
      return { isFetching: true };
    case SOFTWARE.PLATFORMS.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SOFTWARE.PLATFORMS.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getSoftwarePlatformsList;
